<template>
  <div class="track-epaer_browser">
    <div class="condition">
      <div class="form-item form-item-cate">
        <label>报纸类型：</label>
        <el-select v-model="curCate">
          <el-option
            v-for="(item, index) in epaperCate"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="form-item form-item-region">
        <Region
          :region-list="regionList"
          :init-city="cityId"
          :init-province="provinceId"
          @handleCommand="handleCommand"
        />
      </div>
      <div class="form-item">
        <label>发布日期：</label>
        <DatePicker
          separator="至"
          align="center"
          format="MM-dd"
          ref="datepicker"
          :is-contains-cur-time="true"
          :default-time="defaultTime"
          @timeChange="timeChange"
        />
      </div>
      <div class="form-item form-item-name">
        <label>报纸名称：</label>
        <el-input
          v-model="epaperName"
          placeholder="请输入报纸名称"
        />
      </div>
      <el-button @click="search">
        搜索
      </el-button>
    </div>
    <div class="content">
      <div
        class="item"
        v-for="(item, index) in epaperList"
        :key="index"
        @click="browerDetail(item)"
      >
        <el-image
          :src="item.cover"
          fit="cover"
          lazy
        >
          <div
            slot="error"
            class="image-slot"
          >
            <img :src="loadError">
          </div>
        </el-image>
        <div class="bd">
          <div class="bd_intro">
            <span :title="item.name">{{ item.name }}</span>
            <span class="date">{{ item.date.slice(5) }}</span>
          </div>
        </div>
      </div>
      <div
        class="empty"
        v-show="epaperList.length === 0"
      >
        {{ empty }}
      </div>
    </div>
    <el-pagination
      background
      layout="slot,prev, pager, next"
      :total="total"
      :page-size="pagesize"
      :current-page="page"
      @current-change="handleCurrentChange"
      v-show="epaperList.length !== 0"
    >
      <span class="total">
        共
        <em>{{ total }}</em>条信息
      </span>
    </el-pagination>
  </div>
</template>

<script>
import APIS from '@apis/jgsd/epaperSubscribe.js'
import Region from '@components/common/RegionPickerTwo.vue'
import DatePicker from '@components/common/DatePicker.vue'
import { timeFormat, toTopAnimation, getTimeParamCy } from '@common/util.js'
export default {
  name: 'Epaper',
  data() {
    return {
      breadMenuData: ['报刊审读'],
      curCate: 0,
      epaperCate: [],
      provinceId: String(login_cookie['provinceId']),
      cityId: String(login_cookie['cityId']) === '0' ? '' : String(login_cookie['cityId']),
      regionList: [],
      epaperName: '',
      page: 1,
      pagesize: 10,
      total: 0,
      epaperList: [],
      defaultTime: [timeFormat(new Date()), timeFormat(new Date())],
      beginTime: '',
      endTime: '',
      empty: '',
      loadError: require('@assets/imgs/epaper-loadError.png'),
      hasCoverTime: new Date('2020-10-29').setHours(0, 0, 0, 0)
    }
  },
  components: {
    Region,
    DatePicker
  },
  mounted() {
    this.$store.commit('UPDATE_BreadMenuData', [...this.breadMenuData])
    this.beginTime = timeFormat(new Date().setHours(0, 0, 0, 0))
    this.endTime = this.defaultTime[1]
    this.getSourceCate()
    this.getRegion()
  },
  methods: {
    // 报纸类型
    async getSourceCate() {
      let { status, data } = await APIS.postSourceCate({
        data: { dataTypeCode: 'epaper' }
      })
      if (status === 0 && data && data[0]) {
        this.epaperCate = [
          { name: '全部', id: 0 },
          ...data[0].firstSourceCategories
        ]
      } else {
        this.epaperCate = []
      }
    },
    // 地域列表
    async getRegion() {
      let { status, data } = await APIS.postRegions({
        data: { pid: 86, subLevel: 1 }
      })
      if (status === 0 && data && data.length !== 0) {
        this.regionList = [{ name: '全国', id: '86', children: [] }, ...data]
        this.getEpaperList()
      }
    },
    // 报刊浏览列表
    async getEpaperList() {
      let params = {
        typeId: this.curCate,
        provinceId: this.provinceId,
        cityId: this.cityId,
        name: this.epaperName,
        beginTime: this.beginTime.replace(/\//g, '-'),
        endTime: this.endTime.replace(/\//g, '-'),
        page: this.page,
        pagesize: 10
      }
      this.empty = ''
      let { status, data } = await APIS.postEpaperList({ data: params })
      if (status === 0 && data && data.rows && data.rows.length !== 0) {
        this.total = data.total
        this.epaperList = data.rows.map(item => {
          return {
            id: item.id,
            code: item.code,
            name: item.name,
            cover: item.frontPage && item.frontPage.imgUrl,
            date: item.frontPage && item.frontPage.date
          }
        })
      } else {
        this.total = 0
        this.empty = '当前未查询到任何数据'
        this.epaperList = []
      }
      toTopAnimation()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getEpaperList()
    },
    search() {
      this.page = 1
      this.getEpaperList()
    },
    handleCommand(value) {
      if (value.flag === 'region') {
        this.provinceId = String(value.id) === '86' ? '' : value.id
        this.cityId = ''
      } else {
        this.cityId = value.id
      }
    },
    timeChange(value) {
      this.beginTime = value[0]
      this.endTime = value[1]
    },
    // 跳转到指定报刊浏览
    browerDetail(value) {
      let seciffy = this.$router.resolve({
        path: '/jgsd/epaper/review',
        query: {
          modelId: this.$store.state.currentIndex,
          id: value.id,
          date: value.date
        }
      })
      window.open(seciffy.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.track-epaer_browser {
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  .condition {
    position: relative;
    display: flex;
    align-items: center;
    padding: 15px 30px 10px;
  }
  /deep/ .condition {
    .form-item {
      display: flex;
      height: 30px;
      align-items: center;
      margin-right: 30px;
      font-size: 14px;
      label {
        flex-shrink: 0;
      }
      .cy-date-time-picker {
        width: 160px;
        background-color: #fff;
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        .el-date-editor {
          padding-left: 13px;
          &--daterange {
            .el-range-input {
              width: 40px;
            }
          }
        }
        & > .icon {
          right: 9px;
        }
      }
      &-name {
        .el-input {
          display: flex;
          align-items: center;
          position: relative;
          &__inner {
            width: 200px;
            font-size: 13px;
            font-family: "founder_youhei_508R";
            background-color: #fff;
            border-radius: 5px;
          }
          &__suffix {
            cursor: pointer;
            &-inner {
              position: absolute;
              right: 3px;
              top: 9px;
            }
          }
        }
      }
      &.form-item-cate {
        .el-select {
          width: 100px;
        }
      }
      &.form-item-region {
        width: 250px;
        flex-shrink: 0;
      }
      &:last-child {
        margin: 0;
      }
    }
    .el-button {
      position: absolute;
      right: 30px;
      width: 60px;
      height: 30px;
      background: #4497ec;
      border: 1px solid #4497ec;
      border-radius: 5px;
      padding: 0;
      font-size: 13px;
      color: #fff;
      cursor: pointer;
    }
  }
  /deep/ .el-select {
    .el-input {
      &__inner {
        font-size: 13px;
        font-family: "founder_youhei_508R";
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 30px 0;
    min-height: 300px;
    .item {
      width: calc(20% - 16px);
      flex-basis: calc(20% - 16px);
      margin: 0 20px 20px 0;
      height: 355px;
      border: 1px solid #ececec;
      cursor: pointer;
      &:hover {
        border-color: #4497ec;
      }
      /deep/ .el-image {
        height: 304px;
        &__inner {
          width: 100%;
          padding: 5px;
          height: 300px;
        }
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
      .bd {
        display: flex;
        align-items: center;
        padding: 10px 15px 8px 22px;
        justify-content: space-between;
        &_intro {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-size: 14px;
          color: #3a3a3a;
          line-height: 18px;
          span {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .el-button {
          flex-shrink: 0;
          width: 60px;
          height: 25px;
          padding: 0;
          font-size: 14px;
          background: #fafafa;
          border-color: #e7e7e7;
          border-radius: 5px;
        }
      }
    }
  }
  /deep/ .el-pagination {
    padding: 0 0 25px 0;
    text-align: center;
    .el-pager {
      li {
        background-color: #ffffff;
      }
    }
    .btn-prev,
    .btn-next {
      background-color: #ffffff;
    }
    .total {
      font-size: 12px;
      font-weight: normal;
      margin-right: 10px;
      em {
        padding: 0 2px;
        color: #4497ec;
        font-style: normal;
      }
    }
  }
  .empty {
    display: flex;
    width: 100%;
    align-items: center;
    min-height: 400px;
    justify-content: center;
    text-align: center;
    font-size: 13px;
    color: #666;
  }
}
/deep/ .cy-local-hotDetail .related-entities .bd .entities-list {
  width: 100%;
}
</style>
